import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import ReturnProvider from "./context/ReturnContext";
import reportWebVitals from "./reportWebVitals";
import "./i18nextConf";
import { IntlProvider } from "react-intl";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ReturnProvider>
        <IntlProvider locale="it" defaultLocale="it">
          <App />
        </IntlProvider>
      </ReturnProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
